<template>
  <div class="mb-3 position-relative">
    <div class="close radius-0" style="right: 0px" @click="deleteVideo(index)">
      <i style="margin-bottom: 7px" class="fa fa-times f10"></i>
    </div>
    <div class="card-body" style="background-color: #f4f4f4">
      <div v-if="!record" class="row">
        <div class="col-lg-12">
          <label>TÍTULO DO VÍDEO</label>
          <input
            type="text"
            class="form-control mb-2"
            v-model="gallery_item.name"
            :class="{ 'is-invalid': gallery_item.name === '' }"
          />
        </div>
        <div v-show="able_iframe" class="col-lg-12 col-xs-12">
          <label>Url do video</label>
          <input
            class="form-control mb-3"
            placeholder="Plataformas compativeis: YouTube, Vimeo, DailyMotion"
            rows="6"
            v-model="gallery_item.iframe"
          />

          <div class="videoPlayCurrent">
            <video-embed
              :id="`embed${index}`"
              class="mb-3"
              v-if="able_iframe"
              :src="gallery_item.iframe"
            ></video-embed>
            <button @click="saveIframe" type="button" class="btn btn-primary">
              Salvar Vídeo
            </button>
            <button @click="backOption" type="button" class="btn btn-primary">
              <font-awesome-icon
                class="mr-2"
                icon="chevron-left"
              ></font-awesome-icon
              >Voltar
            </button>
          </div>
        </div>
      </div>
      <div v-if="!record && !able_iframe" class="row row-btns">
        <div class="col-lg-3 col-xs-12">
          <button
            @click="canRecord()"
            :disabled="gallery_item.name == ''"
            class="btn btn-sm full btn-primary resize-btn"
          >
            GRAVAR
          </button>
        </div>
        <div class="col-lg-3 col-xs-12">
          <span
            :disabled="gallery_item.name == ''"
            class="btn full btn-sm btn-primary-dark btn-default btn-file resize-btn"
            :class="{ disabled: gallery_item.name == '' }"
          >
            <span v-show="!load_upload">UPLOAD</span>
            <div
              v-show="load_upload"
              class="spinner-border text-light"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <input
              type="file"
              :ref="`file`"
              :disabled="gallery_item.name == ''"
              v-on:change="sendMovieUpload()"
              accept="video/*"
              :id="`capture${index}`"
              capture="camcorder"
            />
          </span>
        </div>
        <div class="col-lg-3 col-xs-12">
          <button
            :disabled="load || gallery_item.name == ''"
            @click="showSelectVideo(index)"
            class="btn btn-sm btn-info full resize-btn"
          >
            <span v-show="!load">GALERIA</span>
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
          </button>
        </div>
        <div class="col-lg-3 col-xs-12">
          <button
            @click="able_iframe = true"
            :disabled="gallery_item.name == ''"
            class="btn btn-sm full btn-secondary resize-btn"
          >
            LINK EXTERNO
          </button>
        </div>
      </div>
      <div
        v-show="gallery_item.video != '' && !record && !able_iframe"
        class="row"
      >
        <div class="col-lg-12 col-xs-12">
          <div class="videoPlayCurrent mt-3">
            <video
              width="100%"
              :id="`video_unique${index}`"
              controls
              controlslist="nodownload"
            >
              <source :src="gallery_item.video" />
            </video>
          </div>
        </div>
      </div>
      <div v-if="record && !able_iframe" class="row">
        <div class="col-lg-12 col-xs-12">
          <div class="videoPlayCurrent center">
            <VideoJSRecordGallery
              class="mt-3"
              :video="gallery_item"
              @setFieldGalleryItem="setFieldGalleryItem"
              :gallery="gallery"
              :item="gallery_item"
              :reference_id="current_reference_id"
              :index="index"
            />
            <button
              @click="backOption"
              type="button"
              class="mt-2 btn btn-primary"
            >
              <font-awesome-icon
                class="mr-2"
                icon="chevron-left"
              ></font-awesome-icon
              >Voltar
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 p-3 col-xs-12">
        <KProgress
          v-if="percent > 0 && percent <= 99"
          :color="['#53358B', '#00baf7']"
          bg-color="#fff"
          :percent="percent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VideoJSRecordGallery from "components/VideoJSRecordGallery.vue";
import SelectVideo from "@/Recruiters/Galleries/SelectVideo.vue";
import KProgress from "k-progress";

export default {
  props: ["index", "item", "requestSave", "job_id", "gallery_current"],
  components: { VideoJSRecordGallery, KProgress },
  data: () => ({
    gallery_item: {
      name: "",
      video_id: 0,
      id: 0,
      description: "",
      video: "",
      reference_id: 0,
      iframe: "",
    },
    load: false,
    load_upload: false,
    record: false,
    able_iframe: false,
    current_reference_id: 0,
    file: "",
    percent: 0,
    gallery: {},
    category_job_presentation: 5,
  }),
  async mounted() {
    this.gallery_item = this.item;
    if (this.job_id == 0) {
      await this.requestSave(false, false).then((response) => {
        eventBus.$emit("setJobId", response);
        this.current_reference_id = response.data.job.id;
        this.gallery = response.data.gallery;
        this.gallery_item.reference_id = response.data.job.id;
      });
    } else {
      this.gallery = this.gallery_current;
      this.gallery.item_category_id = 5;
      this.current_reference_id = this.job_id;
      this.gallery_item.reference_id = this.job_id;
      eventBus.$emit("setLoad", false);
    }

    if (this.gallery_item.iframe != "") {
      this.able_iframe = true;
    }

    eventBus.$on(`setNewGalleryItem${this.index}`, (field) => {
      this.gallery_item = {
        name: field["name"],
        video_id: field["video_id"],
        id: field["id"],
        description: field["description"],
        video: field["video"],
        reference_id: field["reference_id"],
        iframe: field["iframe"],
      };
      if (field["iframe"] != "") {
        this.able_iframe = true;
      }
      document.querySelector(`#video_unique${this.index}`).load();
    });
  },
  methods: {
    backOption() {
      this.load = false;
      this.load_upload = false;
      this.record = false;
      this.able_iframe = false;
    },
    saveIframe() {
      if (this.gallery_item.name == "" || this.gallery_item.iframe == "") {
        this.$toast.error("PREENCHA CORRETAMENTE O CAMPO NOME E URL DO VÍDEO");
        return;
      }

      axios
        .post("/recruiters/galleries/items", {
          galleries: {
            id: this.gallery.id,
            gallery_category_id: this.gallery.category_id,
            reference_id: this.gallery.reference_id,
            item_category_id: this.category_job_presentation,
            name: this.gallery.name,
          },
          gallery_item: {
            id: this.gallery_item.id,
            name: this.gallery_item.name,
            description: this.gallery_item.description,
            reference_id: this.gallery_item.reference_id,
            iframe: this.gallery_item.iframe,
            video_id: this.gallery_item.video_id,
          },
        })
        .then((response) => {
          this.$toast.success("VÍDEO SALVO COM SUCESSO");
          this.gallery_item.id = response.data.gallery_item.id;
        });
    },
    sendMovieUpload() {
      this.able_iframe = false;
      this.percent = 0;
      this.load_upload = true;
      if (this.gallery_item.name == "") {
        this.$toast.error("DIGITE UM TÍTULO DO VÍDEO PARA CONTINUAR");
        this.load_upload = false;
        return;
      }

      let formData = new FormData();
      this.file = this.$refs["file"].files[0];

      formData.append("video[file]", this.file);
      this.gallery_item.video = URL.createObjectURL(
        document.querySelector(`#capture${this.index}`).files[0]
      );

      let video = document.querySelector(`#video_unique${this.index}`);

      video.load();

      video.onloadedmetadata = () => {
        // if (video.duration > 91 || video.duration == Infinity) {
        //   this.load_upload = false;
        //   this.$toast.error(
        //     `Tempo de vídeo maior que 3 minutos, por favor grave um vídeo menor`
        //   );
        //   return;
        // }

        setTimeout(() => {
          let canvas = document.createElement("canvas");
          canvas.className = "hide";
          canvas.width = 480;
          canvas.height = 360;
          document.getElementsByTagName("body")[0].appendChild(canvas);
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          canvas.toBlob((thumb) => {
            formData.append("videos[thumbnail]", thumb);
            formData.append("videos[file]", this.file);
            formData.append("videos[name]", this.gallery_item.name);
            formData.append(
              "videos[description]",
              this.gallery_item.description
            );
            formData.append("videos[id]", this.gallery_item.video_id);

            formData.append(
              "galleries[gallery_category_id]",
              this.gallery.category_id
            );

            formData.append(
              "galleries[reference_id]",
              this.gallery.reference_id
            );
            formData.append("galleries[name]", this.gallery.name);
            formData.append(
              "galleries[item_category_id]",
              this.gallery.item_category_id
            );
            formData.append("galleries[id]", this.gallery.id);
            formData.append("gallery_item[id]", this.gallery_item.id);

            axios
              .post("/recruiters/galleries/videos", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                  const totalLength = progressEvent.lengthComputable
                    ? progressEvent.total
                    : progressEvent.target.getResponseHeader(
                        "content-length"
                      ) ||
                      progressEvent.target.getResponseHeader(
                        "x-decompressed-content-length"
                      );

                  if (totalLength !== null) {
                    this.percent = parseInt(
                      (progressEvent.loaded * 100) / totalLength
                    );
                  }
                },
              })
              .then((resp) => {
                this.load_upload = false;
                this.gallery_item = resp.data.gallery_item;
              })
              .catch(function (error) {
                console.log(error);
              });
          });
        }, 1100);
      };
    },
    setFieldGalleryItem(event) {
      this.able_iframe = false;
      this.$emit("setInstitutionalIndex", {
        id: event.data.gallery_item.id,
        index: this.index,
      });
    },
    deleteVideo(index) {
      if (this.gallery_item.id == 0) {
        this.$emit("deleteInstitutional", index);
        return;
      }

      let conf = confirm("TEM CERTEZA QUE DESEJA DELETAR ESSE ITEM?");
      if (!conf) return;

      axios
        .delete(`/recruiters/galleries/items/${this.gallery_item.id}`)
        .then((response) => {
          this.$toast.success("ITEM REMOVIDO COM SUCESSO.");
          this.$emit("deleteInstitutional", index);
        });
    },
    canRecord() {
      this.able_iframe = false;
      if (this.gallery_item == "") {
        this.$toast.error("DIGITE UM TÍTULO DO VÍDEO");
        return;
      }
      this.record = true;
    },
    showSelectVideo(index) {
      this.load = true;
      if (this.gallery_item == "") {
        this.$toast.error("DIGITE UM TÍTULO DO VÍDEO");
        return;
      }

      this.$modal.show(
        SelectVideo,
        {
          index: index,
          gallery_item: this.gallery_item,
          gallery: this.gallery,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        }
      );
      this.load = false;
    },
  },
};
</script>